// extracted by mini-css-extract-plugin
export default {"products_lobby":"products_lobby___FUnFS"};